import type { Table, Tables } from '@shady-pines/db';
import { isNonNil } from '@shady-pines/types';
import type { RealtimePostgresChangesPayload } from '@supabase/supabase-js';
import { useEffect } from 'react';
import { useSupabase } from '../use-supabase';

const EventType = ['INSERT', 'UPDATE', 'DELETE'] as const;
type EventType = (typeof EventType)[number];

export const useSubscription = <T extends Table>(
  eventType: EventType,
  table: T,
  callback: (payload: RealtimePostgresChangesPayload<Tables<T>>) => void,
  filter?: string,
) => {
  const supabase = useSupabase();
  useEffect(() => {
    const channel = (() => {
      if (isNonNil(filter)) {
        return supabase
          .channel('table-db-changes')
          .on(
            'postgres_changes',
            { event: '*', schema: 'public', table, filter: `id=eq.${filter}` },
            callback,
          )
          .subscribe();
      }
      return supabase
        .channel(`${table}`)
        .on('postgres_changes', { event: '*', schema: 'public', table }, callback)
        .subscribe();
    })();

    return () => {
      void supabase.realtime.removeChannel(channel);
    };
  }, [eventType, table, callback, filter, supabase]);
};
